import React from "react"
import img from "../images/services.jpg"
import Back from "../common/Back"
import "../home/featured/Featured.css"
import FeaturedCard from "../home/featured/FeaturedCard"
import { useLanguage } from "../../context/LanguageContext"

const Services = () => {
  const { content } = useLanguage()
  const { services } = content

  return (
    <>
      <section className='services mb'>
        <Back name={services.backName} title={services.backTitle} cover={img} />
        <div className='featured container'>
          <FeaturedCard />
        </div>
      </section>
    </>
  )
}

export default Services
